<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Template" ripple class="secondary-tab">
			Template
		</v-tab>
		<v-tab key="Scheduling" ripple class="secondary-tab">
			Scheduling
		</v-tab>
		<v-tab key="Stampa" ripple class="secondary-tab">
			Stampa
		</v-tab>
		<v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="background-1 pt-3 pb-1" key="Campi">
			<v-row class="ma-0 ">
				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="quotation"></fields-selector>
				</v-col>
			</v-row>
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="productquotation" audit></fields-selector>
				</v-col>
			</v-row>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="quotation"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="background-1 pt-3 pb-1" key="Template">
			<v-row class="ma-0">
				<v-col class="pa-0" cols="12">
					<crud
						title='Template invio preventivi'
						action-icon='dynamic_feed'
						model-def='templates-quotation'
						action-position='absolute'
					></crud>
				</v-col>
				<v-col class="pa-0 pt-4" cols="12">
					<crud
						title='Template invio preventivi firmati'
						action-icon='dynamic_feed'
						model-def='templates-quotationsign'
						action-position='absolute'
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-1" key="Scheduling">
			<v-row class="ma-0">
				<quotations-scheduling></quotations-scheduling>
			</v-row>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-1" key="Stampa">
			<v-row class="ma-0">
				<quotations-print></quotations-print>
			</v-row>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-1" key="Altro">
			<v-row class="ma-0">
				<quotations-options></quotations-options>
			</v-row>
		</v-tab-item>

	</v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import QuotationsScheduling from '@/components/modules/quotations/settings/QuotationsScheduling'
import QuotationsPrint from '@/components/modules/quotations/settings/QuotationsPrint'
import QuotationsOptions from '@/components/modules/quotations/settings/QuotationsOptions'

	export default {
		name:'quotations-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
            QuotationsScheduling,
            QuotationsPrint,
            QuotationsOptions
        },		
		data() {
			return {

			}
		},
	}
  </script>
